export const getCardImage = ({
  slug = null,
  heroImage = null,
  heroVideo = null,
  image = null,
  width = null,
  height = null,
  contentType = null,
  cardConfigurations = null,
  type = null,
  context = null,
  clientContext = null,
  imagePlaceholder = null
}) => {

  let { isMobile, isAmp } = clientContext;
  let { settings } = context.data;

  let cardImage = {
    image: null,
    url: null,
    title: null,
    analytics: null,
    showPlayIcon: null,
    path: null,
  };

  // If an override width or height is set, use it, otherwise get the default for this type of card.
  // let configurationWidth =
  //   width !== undefined && width !== null
  //     ? width
  //     : cardConfigurations.image[contentType][isMobile ? "mobile" : "desktop"][type].widthValue;
  // let configurationHeight =
  //   height !== undefined && height !== null
  //     ? height
  //     : cardConfigurations.image[contentType][isMobile ? "mobile" : "desktop"][type].heightValue;

  try {
    if (contentType === "article") {
      cardImage = {
        image: heroImage.fields.image,
        width: width,
        height: height,
      };
    } else if (contentType === "list") {
      cardImage = {
        image: image,
        width: width,
        height: height,
      };
    } else if (contentType === "author") {
      // console.log("author image", image);

      if (image === null) {
        image = {
          fields: {
            file: {
              url: imagePlaceholder || "//newsletter.oscars.org/images/Placeholder-TextureBW-logo.png",
              details: {
                image: {
                  width: 285,
                  height: 285
                }
              }
            },
          }
        }
      }
      cardImage = {
        image: image,
        width: width,
        height: height,
      };
    }


    if (
      cardImage !== undefined &&
      cardImage !== null &&
      cardImage.image !== undefined &&
      cardImage.image !== null
    ) {
      let image = cardImage.image;

      cardImage.url = image.fields.file.url;
      cardImage.title = image.fields.title || "Image"; // @TODO Alt caption, could be better?

      cardImage.scaledHeight =
        (image.fields.file.details.image.height * cardImage.width) /
        image.fields.file.details.image.width;
    }

    if (heroVideo && heroVideo.fields.videoUrl) {
      cardImage.showPlayIcon = true;
    }
  } catch (error) {
    console.error("image error", error);
  }

  return cardImage;
};
